import { render, staticRenderFns } from "./GorssProfit.vue?vue&type=template&id=1c5b0fcc"
import script from "./GorssProfit.vue?vue&type=script&lang=js"
export * from "./GorssProfit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports